import React, { useEffect, useState } from 'react';
import { useToasts } from 'react-toast-notifications';
import { Row, Col, Button, ListGroup, ListGroupItem, Label } from 'reactstrap';
import { ExpandableBox } from '@galop/component-library';
import { makeCall } from '../../auth-utils';
import { api, globalErrorHandler } from '../../api/create-api';
import { Field } from '@galop/component-library';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faTimes, faCheck, faEdit, faList, faBars } from '@fortawesome/free-solid-svg-icons';
import { GetOptionText } from '../../Helpers/Helper';
import Lock, { AppIsLocked } from '../Shared/Lock';

export const Program = (props) => {
    const { index, showBackground, updateProgramQuestion, editProgram, setEditProgram, questions, program, RemoveProgram, eraPrograms, eraStatuses, updateProgram } = props;
    const editable = !AppIsLocked();

    const getProgramAnswer = (id, field = 'answer') => {
        return ((program.answers || []).find(answer => answer.questionId === id) || {})[field];
    }

    return (
        props.Header ?
            <div className="px-3">
                <Row className="align-items-center">
                    <Col>
                        Name
                </Col>
                    {questions && questions.filter(question => question.type === 'ERAProgram').map(question =>
                        <Col key={`${question.id}_Header`} /*className="pb-2 border-bottom mb-2"*/>
                            {question.text}
                        </Col>
                    )}
                    <Col>
                    </Col>
                </Row>
            </div>
            :
            (editProgram ?
                <div className={`bg-white border shadow rounded mb-3 p-2`}>
                    <Row className="align-items-top">
                        <Col sm="8" md="6" lg="7" xl="5" className="order-2 order-sm-1">
                            <Field type="text" className="mb-2" field="name" HideHelp={!program.invalidName} help={program.invalidName ? 'This name already exists. Please use a different name.' : ''} fieldClassName={program.name ? '' : 'is-invalid'} value={program.name} label="Program Name" EnableInput={{ disabled: !editable }} onChange={(e) => updateProgram(e.target.name, e.target.value, program, index)} />
                        </Col>
                        <Col className="text-right order-1 order-sm-2">
                            <Lock
                                locked={() =>
                                    <Button color="light" size="sm" className="border mr-1" onClick={() => {
                                        setEditProgram(!editProgram);
                                        delete program.new;
                                    }} disabled={!program.name}><FontAwesomeIcon className="text-dark" icon={faBars} /> Hide Details</Button>
                                    }
                                unlocked={() =>
                                    <Button color="light" size="sm" className="border mr-1" onClick={() => {
                                    setEditProgram(!editProgram);
                                    delete program.new;
                                }} disabled={!program.name}><FontAwesomeIcon className="text-success" icon={faCheck} /><span className="d-none d-xl-inline"> Accept</span></Button>
                            }
                            />
                            {program.new && <Button color="light" size="sm" className="border" onClick={RemoveProgram}><FontAwesomeIcon className="" icon={faTimes} /><span className="d-none d-xl-inline"> Cancel</span></Button>}
                        </Col>
                    </Row>
                    <div className="border-top">
                        <Row>
                            {questions && questions.filter(question => question.type === 'ERAProgram').map(question =>
                                <Col sm="4" key={`${question.id}_Question`} /*className="pb-2 border-bottom mb-2"*/>
                                    <div className="mb-2">
                                        <Label className="mt-2 mb-0">{question.text}</Label>
                                        <Field type="select" HideHelp={!question.allowMultiple} help={question.allowMultiple ? 'Select all that Apply' : ''} HideLabel fieldClassName={getProgramAnswer(question.id) ? '' : 'is-invalid'} className={question.allowMultiple ? '' : 'mb-3'} field={`answer_${question.id}`} value={getProgramAnswer(question.id)} label={question.text} EnableInput={{ disabled: !editable }} onChange={(e) => updateProgramQuestion(question.allowMultiple ? 'answers' : 'answer', e.target.value, question.id, program, index)}>
                                            <option value="">Select an Answer</option>
                                            {question.options.sort((a, b) => a.order - b.order).filter(option => !question.allowMultiple || !(getProgramAnswer(question.id, 'answers') || []).includes(option.optionText)).map(option => <option key={`${option.questionId}_${option.optionText}`} value={option.optionText}>{option.optionText}</option>)}
                                        </Field>
                                        {question.allowMultiple &&
                                            <ListGroup>
                                                {(getProgramAnswer(question.id, 'answers') || []).filter(answer => !!answer).map(answer =>
                                                    <ListGroupItem key={answer} className="d-flex">
                                                        <div className="flex-fill mr-1">{answer}</div>
                                                        {editable && <div><FontAwesomeIcon className="text-danger" icon={faTimes} onClick={() => updateProgramQuestion('answers', answer, question.id, program, index)} /></div>}
                                                    </ListGroupItem>
                                                )}
                                            </ListGroup>
                                        }
                                    </div>
                                </Col>
                            )}
                        </Row>
                    </div>
                </div>
                :
                <div className={`${showBackground && 'bg-light'} rounded p-2`}>
                    <Row className="align-items-center">
                        <Col>
                            {program.name}
                        </Col>
                        {questions && questions.filter(question => question.type === 'ERAProgram').map(question =>
                            <Col key={`${question.id}_Answer`} /*className="pb-2 border-bottom mb-2"*/>
                                {question.allowMultiple ? (getProgramAnswer(question.id, 'answers') || []).map(answer => <div key={`view_${question.id}_${answer}`}>{answer}</div>) : getProgramAnswer(question.id)}
                            </Col>
                        )}
                        <Lock
                            locked={() =>
                                <Col className="text-right">
                                    <Button color="secondary" size="sm" className="mr-1" outline onClick={() => setEditProgram(!editProgram)}><FontAwesomeIcon icon={faList} /><span className="d-none d-xl-inline"> Show Details</span></Button>
                                </Col>
}
                            unlocked={() =>
                                <Col className="text-right">
                                    <Button color="secondary" size="sm" className="mr-1" outline onClick={() => setEditProgram(!editProgram)}><FontAwesomeIcon icon={faEdit} /><span className="d-none d-xl-inline"> Edit</span></Button>
                                    <Button color="danger" size="sm" outline onClick={RemoveProgram}><FontAwesomeIcon icon={faTimes} /><span className="d-none d-xl-inline"> Delete</span></Button>
                                </Col>
                            }
                        />
                    </Row>
                </div>)
    );
};


// WEBPACK FOOTER //
// ./src/components/Assets/Program.js